import { GlobalStyles } from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";
import "../styles/main.scss";
import useWindowSize from "../hooks/useWindowSize";
import { usePlaylist } from "../contexts/PlaylistContext";
import { BREAKPOINT, TypeOfWindowUndefined } from "./_helpers";
import AnimatedGrain from "./Grain/AnimatedGrain";
import Header from "./header";
import Main from "./main";
import MusicPlayerModal from "./templates/ArtistTemplate/MusicPlayerModal";
import PlaylistPanel from "./templates/ArtistTemplate/PlaylistPanel";

const SITE_TITLE = "Truevined Official Artist Website";

interface SongData {
  primaryArtist?: string;
  title?: string;
  featuredArtist?: string;
  artwork?: string;
  artistBio?: string;
}

interface LayoutProps {
  artwork?: string;
  children: React.ReactNode;
  song?: SongData;
  showGrain?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ artwork, children, song, showGrain }) => {
  const windowSize = useWindowSize();
  const reallyIsMobile = isMobile || windowSize.width <= BREAKPOINT;
  const { isPlayerModalOpen, closePlayerModal } = usePlaylist();
  const artistPageStyles = {
    "*::-webkit-scrollbar": {
      width: "12px",
      backgroundColor: "var(--color1)",
    },
    "*::-webkit-scrollbar-track": {
      backgroundColor: "var(--scrollbarTrackColor)",
    },
    "*::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      backgroundColor: "var(--color1)",
    },
    ".MuiLink-root, .MuiTypography-root.MuiLink-root": {
      textDecoration: "none",
    },
  };
  const releasePageStyles = {
    "*::-webkit-scrollbar": {
      width: "12px",
      backgroundColor: "var(--color1)",
    },
    "*::-webkit-scrollbar-track": {
      backgroundColor: "var(--color1)",
    },
    "*::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      backgroundColor: "rgb(1 1 1 / 32%)",
    },
    ".MuiLink-root, .MuiTypography-root.MuiLink-root": {
      textDecoration: "none",
    },
    ".release-info a, .release-info a.MuiLink-root, .release-info .MuiLink-root": {
      color: "inherit !important",
    },
  };

  const isReleasePage = TypeOfWindowUndefined()
    ? false
    : window.location.pathname.includes("/albums/") ||
      window.location.pathname.includes("/songs/") ||
      window.location.pathname.includes("/podcast/") ||
      window.location.pathname.includes("/videos/") ||
      window.location.pathname.includes("/episode/");

  return (
    <>
      <GlobalStyles
        styles={{
          ...(isReleasePage ? releasePageStyles : artistPageStyles),
        }}
      />
      <Header siteTitle={SITE_TITLE} />
      <Main artwork={artwork} sampleRegion={isReleasePage ? "full" : "edges"}>{children}</Main>
      {!reallyIsMobile && showGrain && <AnimatedGrain />}
      <PlaylistPanel />
      <MusicPlayerModal isVisible={isPlayerModalOpen} onClose={closePlayerModal} />
    </>
  );
};

export default Layout;
